import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcAllItemsLoadedList]'
})
export class AllItemsLoadedListDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
